@use 'sass:map';
@import '../../themes/capsule.globals';

:host {
  display: block;

  position: relative;
  top: 0;
  width: 100%;
  z-index: map.get($z-indices, 'app-bar');
}

.container {
  display: flex;
  width: 100%;
}
